import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { AssessmentType } from "types/graphql-schema";

import Assessment from "@apps/assessments/components/assessment/assessment";
import ComplianceProgram from "@apps/programs/components/compliance-program";
import ComplianceProgramForm from "@apps/programs/components/compliance-program-form/compliance-program-form";
import { ComplianceProgramType } from "@apps/programs/components/compliance-program-form/types";
import {
  ProgramsSection,
  ProgramsSectionContext,
} from "@apps/programs/programs-section-context";
import { isAdminVar, isManagerVar } from "@cache/cache";
import useDocumentTitle from "@components/use-document-title/use-document-title";

import EngagementSurveyHomepage from "./components/homepage";

const programsSection: ProgramsSection = {
  basePath: "/survey/program",
  listUrl: "/survey/all",
  rootCrumb: { title: "Surveys", url: "/survey" },
  lockedProgramType: ComplianceProgramType.ENGAGEMENT_SURVEY,
  assessmentTypes: [AssessmentType.EngagementSurvey],
  noun: "Survey",
  nounPlural: "Surveys",
  listEmptyText: "No surveys.",
};

const EngagementSurvey = () => {
  useDocumentTitle("Surveys");
  const { path } = useRouteMatch();
  const isAdmin = isAdminVar();
  const isManager = isManagerVar();
  const canManage = isAdmin || isManager;

  return (
    <ProgramsSectionContext.Provider value={programsSection}>
      <Switch>
        <Route exact path={[`${path}/delivered`, `${path}/active`, `${path}`]}>
          <EngagementSurveyHomepage />
        </Route>

        {canManage && (
          <Route
            exact
            path={[`${path}/all`, `${path}/progress`, `${path}/results`]}
          >
            <EngagementSurveyHomepage />
          </Route>
        )}
        <Route
          exact
          path={[
            `${path}/program/:complianceProgramId(\\d+)`,
            `${path}/program/:complianceProgramId(\\d+)/actions`,
            `${path}/program/:complianceProgramId(\\d+)/reminders`,
            `${path}/program/:complianceProgramId(\\d+)/activity`,
            `${path}/program/:complianceProgramId(\\d+)/progress`,
            `${path}/program/:complianceProgramId(\\d+)/reporting/:reportTab?`,
          ]}
        >
          <ComplianceProgram />
        </Route>

        {(isAdmin || isManager) && (
          <Route
            exact
            path={[
              `${path}/program/new`,
              `${path}/program/:complianceProgramId(\\d+)/edit`,
              `${path}/program/:complianceProgramId(\\d+)/duplicate`,
            ]}
          >
            <ComplianceProgramForm />
          </Route>
        )}

        <Route exact path={`${path}/assessment/:assessmentId(\\d+)`}>
          <Assessment />
        </Route>

        {/* Non-managers hitting a management-only tab URL land on Active. */}
        <Route>
          <Redirect to={path} />
        </Route>
      </Switch>
    </ProgramsSectionContext.Provider>
  );
};

export default EngagementSurvey;
